import React from 'react'
import SubNavbar from '../components/SubNavbar'
import Navbar from '../components/Navbar'
import PageHeading from '../Properties/PageHeading'
import ContactPageSection from './ContactPageSection'
import FooterContact from './FooterContact'
import { CartProvider } from 'react-use-cart'

function AllContact() {
  return (
    <CartProvider>
        <SubNavbar/>
        <Navbar/>
        <PageHeading/>
        <ContactPageSection/>
        <FooterContact/>
        
    </CartProvider>
  )
}

export default AllContact